import React, { FC } from 'react';
import { Box, Skeleton } from '@mui/material';

const RideAddContactSkeleton: FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 194,
        width: 315,
        overflow: 'hidden',
        borderRadius: 1,
      }}
    >
      {Array.from({ length: 1 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            p: 1.5,
            height: 64,
          }}
        >
          <Skeleton
            variant="circular"
            width={45}
            height={45}
            sx={{ flexShrink: 0 }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="70%" height={22} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="50%" height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RideAddContactSkeleton;
